<template>
  <div class="page-wrapper">
    <HeaderComponent />
    <main class="page-content">
      <!-- <AppBreadcrumb :items="[{ label: $t('common.home') }]" /> -->

      <!-- Personalized Welcome Header -->
      <section class="welcome-header">
        <div class="welcome-text">
          <h1 class="welcome-title">{{ $t('common.welcome', 'Xush kelibsiz') }} 👋</h1>
          <p class="welcome-subtitle">Bugun qanday testlarni ishlashni xohlaysiz?</p>
        </div>
        <div class="welcome-stats">
          <div class="stat-pill">
            <CheckCircleOutlined class="stat-icon" />
            <span>Yangi 2026 Savollar bazasi</span>
          </div>
        </div>
      </section>

      <!-- Premium Banner -->
      <div v-if="!isPremium" class="premium-card">
        <div class="premium-card-bg"></div>
        <div class="premium-content">
          <div class="premium-icon-wrap">
            <CrownOutlined />
          </div>
          <div class="premium-text">
            <h3>{{ $t('home.premiumBannerTitle') }}</h3>
            <p>{{ $t('home.premiumBannerText') }}</p>
          </div>
        </div>
        <a href="https://t.me/smartypx_bot" target="_blank" class="premium-btn">
          {{ $t('home.premiumBannerBtn') }}
          <RightOutlined class="btn-arrow" />
        </a>
      </div>

      <!-- Main Layout: 2 Columns -->
      <div class="dashboard-layout">

        <!-- Left Column: Main Tests -->
        <div class="main-column">
          <!-- <div class="section-header">
            <div class="sh-icon blue-icon">
              <FileTextOutlined />
            </div>
            <div>
              <h2 class="sh-title">Asosiy testlar</h2>
              <p class="sh-subtitle">Imtihonga tayyorlanish uchun asosiy rejimlar</p>
            </div>
          </div> -->

          <div class="test-grid">
            <router-link v-for="(item, i) in mainTests" :key="item.key" :to="item.disabled ? '#' : item.to"
              class="test-card" :class="[{ 'is-disabled': item.disabled }]" @click="handleCardClick($event, item)"
              :style="{ animationDelay: `${i * 0.05}s` }">
              <div class="card-icon-wrapper" :class="`bg-${item.accent}`">
                <component :is="item.iconComponent" class="card-icon" />
              </div>
              <div class="card-info">
                <h3>{{ item.title }}</h3>
                <p>{{ item.description }}</p>
              </div>
              <div class="card-action">
                <div v-if="item.badge" class="pro-badge">
                  <CrownOutlined /> PRO
                </div>
                <div v-else class="action-btn">
                  <RightOutlined />
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <!-- Right Column: Learning & Tools -->
        <div class="side-column">

          <!-- <div class="section-header">
            <div class="sh-icon orange-icon">
              <AppstoreAddOutlined />
            </div>
            <div>
              <h2 class="sh-title">O'rganish vositalari</h2>
              <p class="sh-subtitle">Qo'shimcha materiallar va o'quv katalogi</p>
            </div>
          </div> -->

          <div class="tools-list">
            <router-link v-for="(item, i) in learningTools" :key="item.key" :to="item.disabled ? '#' : item.to"
              class="tool-card" :class="[{ 'is-disabled': item.disabled }]" @click="handleCardClick($event, item)"
              :style="{ animationDelay: `${i * 0.05}s` }">
              <div class="tool-icon-wrapper" :class="`bg-${item.accent}`">
                <component :is="item.iconComponent" />
              </div>
              <div class="tool-info">
                <h4>{{ item.title }}</h4>
                <span v-if="item.badge" class="tool-badge">{{ item.badge }}</span>
              </div>
              <RightOutlined class="tool-arrow" />
            </router-link>
          </div>

        </div>

      </div>

      <!-- Premium Modal -->
      <a-modal v-model:visible="showPremiumModal" :title="$t('home.premiumBannerTitle')" :footer="null" centered>
        <div class="premium-modal-content">
          <p>{{ $t('home.premiumBannerText') }}</p>
          <a-button type="primary" href="https://t.me/smartypx_bot" target="_blank" block class="premium-btn-modal">
            {{ $t('home.premiumBannerBtn') }}
          </a-button>
        </div>
      </a-modal>
    </main>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'
import {
  FormOutlined, OrderedListOutlined, ReadOutlined, AimOutlined,
  CloseCircleOutlined, WarningOutlined, NodeIndexOutlined,
  MedicineBoxOutlined, DollarOutlined, TrophyOutlined,
  BookOutlined, ThunderboltOutlined,
  CheckCircleOutlined, CarOutlined, CrownOutlined,
  FileTextOutlined, AppstoreAddOutlined, RightOutlined,
  PlayCircleOutlined
} from '@ant-design/icons-vue'

export default {
  name: 'HomeView',
  components: {
    HeaderComponent, AppBreadcrumb,
    FormOutlined, OrderedListOutlined, ReadOutlined, AimOutlined,
    CloseCircleOutlined, WarningOutlined, NodeIndexOutlined,
    MedicineBoxOutlined, DollarOutlined, TrophyOutlined,
    BookOutlined, ThunderboltOutlined,
    CheckCircleOutlined, CarOutlined, CrownOutlined,
    FileTextOutlined, AppstoreAddOutlined, RightOutlined,
    PlayCircleOutlined
  },
  data() {
    return { showPremiumModal: false }
  },
  computed: {
    isPremium() { return this.$store.getters['auth/isPremium'] },
    mainTests() {
      const p = this.isPremium
      return [
        { key: 'real-exam', title: this.$t('home.realExam'), description: this.$t('home.realExamDesc'), to: '/real-exam', iconComponent: 'FormOutlined', accent: 'blue' },
        { key: 'tickets-10', title: this.$t('home.tickets10'), description: this.$t('home.tickets10Desc'), to: '/tickets/10', iconComponent: 'OrderedListOutlined', accent: 'cyan', badge: !p ? 'PRO' : null, disabled: !p, isPremiumLocked: !p },
        { key: 'tickets-20', title: this.$t('home.tickets20'), description: this.$t('home.tickets20Desc'), to: '/tickets/20', iconComponent: 'ReadOutlined', accent: 'indigo', badge: !p ? 'PRO' : null, disabled: !p, isPremiumLocked: !p },
        { key: 'tickets-50', title: this.$t('home.tickets50'), description: this.$t('home.tickets50Desc'), to: '/tickets/50', iconComponent: 'AimOutlined', accent: 'violet', badge: !p ? 'PRO' : null, disabled: !p, isPremiumLocked: !p },
        { key: 'challenge', title: 'Musobaqa', description: 'Do\'stlar bilan bellashing', to: '/challenge', iconComponent: 'TrophyOutlined', accent: 'amber' },
        { key: 'wrong-questions', title: this.$t('home.wrongQuestions'), description: this.$t('home.wrongQuestionsDesc'), to: '/wrong-questions', iconComponent: 'CloseCircleOutlined', accent: 'rose', badge: !p ? 'PRO' : null, disabled: !p, isPremiumLocked: !p }
      ]
    },
    learningTools() {
      return [
        { key: 'topics', title: 'Mavzular katalogi', description: '29 ta bob bo\'yicha testlar', to: '/topics', iconComponent: 'BookOutlined', accent: 'blue' },
        { key: 'flashcards', title: 'Flesh Card', description: 'Kartochkalar orqali o\'rganing', to: '/flashcards', iconComponent: 'ThunderboltOutlined', accent: 'violet' },
        { key: 'road-signs', title: this.$t('home.roadSigns'), description: this.$t('home.roadSignsDesc'), to: '/road-signs', iconComponent: 'NodeIndexOutlined', accent: 'green' },
        { key: 'fine-points', title: this.$t('home.finePoints'), description: this.$t('home.finePointsDesc'), to: '/fine-points', iconComponent: 'WarningOutlined', accent: 'amber' },
        { key: 'medical-info', title: this.$t('home.medicalInfo'), description: this.$t('home.medicalInfoDesc'), to: '/medical-info', iconComponent: 'MedicineBoxOutlined', accent: 'teal', badge: this.$t('home.badgeInProgress'), disabled: true },
        { key: 'fines', title: this.$t('home.fines'), description: this.$t('home.finesDesc'), to: '/fines', iconComponent: 'DollarOutlined', accent: 'orange', badge: this.$t('home.badgeInProgress'), disabled: true },
      ]
    }
  },
  mounted() {
    this.$store.dispatch('auth/fetchPremiumStatus')
  },
  methods: {
    handleCardClick(e, item) {
      if (item.disabled) {
        e.preventDefault()
        if (item.isPremiumLocked) this.showPremiumModal = true
        else message.info(this.$t('home.sectionNotReady'))
      }
    }
  }
}
</script>

<style scoped>
/* ===== Layout ===== */
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
}

.page-content {
  flex: 1;
  padding: 0 24px 40px;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
}

/* ===== Welcome Header ===== */
.welcome-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 20px;
  margin: 16px 0 32px;
  box-shadow: var(--shadow);
}

.welcome-title {
  font-size: 24px;
  font-weight: 800;
  color: var(--text);
  margin: 0 0 4px;
}

.welcome-subtitle {
  font-size: 15px;
  color: var(--text-soft);
  margin: 0;
}

.stat-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: rgba(59, 130, 246, 0.08);
  color: var(--primary);
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid rgba(59, 130, 246, 0.2);
}

.stat-icon {
  font-size: 16px;
}

/* ===== Premium Card ===== */
.premium-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 20px;
  margin-bottom: 40px;
  overflow: hidden;
  box-shadow: var(--shadow);
}

.premium-card-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.08), rgba(239, 68, 68, 0.08));
  pointer-events: none;
}

.premium-content {
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  z-index: 2;
}

.premium-icon-wrap {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #f59e0b, #ef4444);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  box-shadow: 0 8px 16px rgba(245, 158, 11, 0.3);
}

.premium-text h3 {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
}

.premium-text p {
  margin: 0;
  font-size: 14px;
  color: var(--text-soft);
}

.premium-btn {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--text);
  color: var(--bg);
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  transition: transform 0.2s;
}

.premium-btn:hover {
  transform: translateY(-2px);
  color: var(--bg);
}

/* ===== Dashboard Layout ===== */
.dashboard-layout {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 40px;
}

/* Section Headers */
.section-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.sh-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.blue-icon {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.purple-icon {
  background: rgba(139, 92, 246, 0.1);
  color: #8b5cf6;
}

.orange-icon {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.sh-title {
  margin: 0 0 2px;
  font-size: 20px;
  font-weight: 700;
  color: var(--text);
}

.sh-subtitle {
  margin: 0;
  font-size: 14px;
  color: var(--text-soft);
}

/* Main Grid */
.test-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.test-card {
  display: flex;
  flex-direction: column;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 24px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: fadeUp 0.5s backwards;
}

.test-card.is-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.test-card:not(.is-disabled):hover {
  transform: translateY(-4px);
  border-color: var(--primary);
  box-shadow: var(--shadow);
}

.card-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 20px;
}

.bg-blue {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.bg-cyan {
  background: rgba(6, 182, 212, 0.1);
  color: #06b6d4;
}

.bg-indigo {
  background: rgba(99, 102, 241, 0.1);
  color: #6366f1;
}

.bg-violet {
  background: rgba(139, 92, 246, 0.1);
  color: #8b5cf6;
}

.bg-rose {
  background: rgba(244, 63, 94, 0.1);
  color: #f43f5e;
}

.bg-amber {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.card-info h3 {
  font-size: 17px;
  font-weight: 700;
  color: var(--text);
  margin: 0 0 8px;
}

.card-info p {
  font-size: 13px;
  color: var(--text-soft);
  margin: 0;
  line-height: 1.5;
  flex: 1;
}

.card-action {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.action-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--bg);
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-soft);
  transition: all 0.2s;
}

.test-card:not(.is-disabled):hover .action-btn {
  background: var(--primary);
  color: white;
  border-color: var(--primary);
}

.pro-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid rgba(245, 158, 11, 0.2);
}



/* Tools List */
.tools-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tool-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  transition: all 0.2s;
  animation: fadeUp 0.5s backwards;
}

.tool-card.is-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.tool-card:not(.is-disabled):hover {
  border-color: var(--text-soft);
  transform: translateX(4px);
}

.tool-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.bg-green {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.bg-orange {
  background: rgba(249, 115, 22, 0.1);
  color: #f97316;
}

.bg-teal {
  background: rgba(20, 184, 166, 0.1);
  color: #14b8a6;
}

.tool-info {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.tool-info h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
}

.tool-badge {
  font-size: 11px;
  padding: 2px 8px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 100px;
  color: var(--text-soft);
}

.tool-arrow {
  color: var(--text-soft);
  font-size: 14px;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 1024px) {
  .dashboard-layout {
    grid-template-columns: 1fr;
  }

  .hero-section {
    padding: 32px;
  }

  .hero-graphic {
    display: none;
  }
}

@media (max-width: 768px) {
  .test-grid {
    grid-template-columns: 1fr;
  }

  .hero-actions {
    flex-direction: column;
  }

  .premium-card {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
}
</style>